import { blaetterSlots, slotAnzahl, spalten, type Operation, type Slot, type UiDaten } from "@gui-creator/gemeinsam";

export type Ablage = { gui_creator: 1; slots: { dr: number; dc: number; slot: Slot }[] };

export function kopiere(ui: UiDaten, auswahl: number[]): Ablage | null {
  const s = spalten(ui.form);
  const belegt = auswahl.filter((i) => ui.slots[i]).sort((a, b) => a - b);
  if (belegt.length === 0) return null;
  const r0 = Math.min(...belegt.map((i) => Math.floor(i / s)));
  const c0 = Math.min(...belegt.map((i) => i % s));
  return { gui_creator: 1, slots: belegt.map((i) => ({ dr: Math.floor(i / s) - r0, dc: (i % s) - c0, slot: structuredClone(ui.slots[i]!) })) };
}

export function lies(text: string): Ablage | null {
  try {
    const a = JSON.parse(text) as Ablage;
    return a && a.gui_creator === 1 && Array.isArray(a.slots) ? a : null;
  } catch {
    return null;
  }
}

/** Setzt die Ablage mit ihrer linken oberen Ecke auf das Ziel; Listen- und Blätterplätze bleiben frei. */
export function einfuegeOps(a: Ablage, ziel: number, ui: UiDaten): Operation[] {
  const s = spalten(ui.form);
  const n = slotAnzahl(ui.form);
  const gesperrt = new Set([...ui.listen.flatMap((l) => l.slots), ...blaetterSlots(ui)]);
  const zr = Math.floor(ziel / s);
  const zc = ziel % s;
  const setzen: { index: number; slot: Slot }[] = [];
  for (const e of a.slots) {
    const c = zc + e.dc;
    const index = (zr + e.dr) * s + c;
    if (c >= s || index >= n || gesperrt.has(index)) continue;
    setzen.push({ index, slot: e.slot });
  }
  if (setzen.length === 0) return [];
  return [{ art: "slots_leeren", indizes: setzen.map((x) => x.index) }, ...setzen.map((x) => ({ art: "slot_setzen" as const, index: x.index, felder: x.slot }))];
}
